import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Box, Typography, IconButton} from 'views/components';
import {Link} from 'views/components';
import {ArrowDropDown, ArrowDropUp} from 'views/icons';
import {Translate} from 'views/module';

const UserOptions = (props) => {
  return (
    <>
      <Box
        sx={{
          backgroundColor: 'navbar.main',
          py: '8px',
          pointerEvents: 'auto',
          width: '200px',
        }}
      >
        <Link
          href={'/signout'}
          sx={{
            'textDecoration': 'none',
            '&:hover': {
              textDecoration: 'none',
            },
          }}
        >
          <Typography
            sx={{
              'color': 'navbar.text',
              'py': '8px',
              'pl': '32px',
              '&:hover': {
                'backgroundColor': 'background.highlighted',
                'borderRadius': '6px',
              },
            }}
          >
            <Translate expression={'navbar.SignOut'} />
          </Typography>
        </Link>
      </Box>
    </>
  );
};
UserOptions.propTypes = {
};

const NavbarUser = (props) => {
  const [expand, setExpand] = React.useState(false);

  const user = props.user;

  return (
    <Box
      sx={{
        py: 2,
        pl: 1,
        width: '100%',
      }}
    >
      <IconButton
        color="primary"
        component="span"
        size="large"
        onClick={() => setExpand((e) => !e )}
        sx={{
          width: '20%',
        }}
      >
        {
          expand ?
            <ArrowDropUp
              sx={{color: 'navbar.text'}}
            /> :
            <ArrowDropDown
              sx={{color: 'navbar.text'}}
            />
        }
      </IconButton>
      <Typography variant='h5'
        sx={{
          color: 'navbar.text',
          fontWeight: 500,
          fontSize: '16px',
          display: 'inline-block',
          textAlign: 'left',
          verticalAlign: 'middle',
          pl: '16px',
          width: '80%',
        }}
      >
        {user.firstName} {user.lastName}
      </Typography>
      {
        expand &&
        <UserOptions
        />
      }
    </Box>
  );
};
NavbarUser.propTypes = {
  user: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps, dispatch)(React.memo(NavbarUser));
